module.exports = __webpack_public_path__ + "e0106718/img/menu-icon.5f8facae.svg";